/* eslint-disable default-case */
const INITIAL_STATE = {
    filteredFaturaRelatorio:{
        faturas: [],
        total: 0,
        pagina: 1,
        ultimaPagina:1,
    },
    preloadFiltersFaturaRelatorio: {
        fatura_id: '',
        forma_pagamento: '',
        nome: '',
        data_inicial: '',
        data_final: '',
        enum_status: '',
    }
}

export default (state = INITIAL_STATE, action) => {
    switch(action.type){
        case 'SET_FILTERED_FATURA_RELATORIO':
            return {...state, filteredFaturaRelatorio: action.payload}
        case 'SET_PRELOADS_FILTER_FATURA_RELATORIO':
            return {...state, preloadFiltersFaturaRelatorio: action.payload}
        default: return state;
    }
}
